/**
 * Sanitize streamed AI Assistant text before rendering.
 *
 * The Claude model occasionally emits markdown formatting and decorative
 * emojis, which we don't want in a clinical assistant UI (they make the
 * response feel less professional and can throw off screen readers). This
 * function strips markdown bold/italic/headers/list-bullets/code-ticks and
 * removes any non-smiley emoji, keeping only a small allow-list.
 */

// Smileys are OK — they add warmth without cluttering the medical tone.
export const ALLOWED_SMILEYS = ["🙂", "😊", "☺️", "☺", "😀", "😃", "😄"];

const EMOJI_REGEX = /(\p{Extended_Pictographic}(\u200D\p{Extended_Pictographic})*\uFE0F?)/gu;

export function sanitizeAIText(text) {
  if (!text) return text;
  let out = text;
  // Strip markdown bold/italic markers (** __ * _ around words) — keep inner text
  out = out.replace(/\*\*(.+?)\*\*/gs, "$1");
  out = out.replace(/__(.+?)__/gs, "$1");
  out = out.replace(/(^|[\s(])\*(\S.*?\S|\S)\*(?=[\s).,!?:;]|$)/gs, "$1$2");
  out = out.replace(/(^|[\s(])_(\S.*?\S|\S)_(?=[\s).,!?:;]|$)/gs, "$1$2");
  // Strip leading markdown headers / list bullets
  out = out.replace(/^#{1,6}\s+/gm, "");
  out = out.replace(/^[ \t]*[•\-]\s+/gm, "");
  // Strip inline code backticks (keep text)
  out = out.replace(/`+([^`]*)`+/g, "$1");
  // Remove any emoji that's not in the allowed smiley list
  out = out.replace(EMOJI_REGEX, (m) => (ALLOWED_SMILEYS.includes(m) ? m : ""));
  // Tidy double spaces left by removals
  out = out.replace(/[ \t]{2,}/g, " ");
  return out;
}
